import React from "react";
import LoadingBtn from "../../../Loading/components/LoadingBtn/LoadingBtn";
import {  useSelector } from "react-redux";

const SubmitBtn = ({ modalData, funcType }) => {
  const { studentPerformanceCommonModalLoading } = useSelector(
    (state) => state.studentPerformanceCommonModal,
  );

  // console.log(studentPerformanceCommonModalLoading,"loading")
 
  return (
    <div className="create-update-modal-btn">
      <button disabled={ studentPerformanceCommonModalLoading}>
        {studentPerformanceCommonModalLoading ? (
          <LoadingBtn />
        ) : funcType === "update" ? (
          "Yenilə"
        ) : (
          "Yarat"
        )}
      </button>
    </div>
  );
};

export default SubmitBtn;
